<template>
  <q-page>
    
    <div class="row content">
      <div class="col-5">
        <q-datetime v-model="dateFrom" type="date" float-label="Von Datum" format="D.MMM.YYYY" />
      </div>
      <div class="col-2"></div>
      <div class="col-5">
        <q-datetime v-model="dateTo" type="date" float-label="Bis Datum" format="D.MMM.YYYY" />
      </div>
    </div>
   

    <div class="row">
      <div class="col">
        <WorkSummary v-bind:dateFrom="dateFrom" v-bind:dateTo="dateTo"></WorkSummary>
      </div>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import WorkSummary from '@/components/Summary/WorkSummary'

export default {
  name: 'Journal',
  components: {
    WorkSummary,
  },
  data: function () {
    return {
      dateFrom: date.startOfDate(Date.now(), 'month'),
      dateTo: date.addToDate(Date.now(), { days: 0 }),
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
